import tw from 'twin.macro';

import { Loader } from '@components/Loader';
import { ActionCellType } from '@account_module/types/Organizations';
import { ThreeDots } from '@icons/ThreeDots';
import { EnvelopeIcon } from '@icons/EnvelopeIcon';
import { DuplicateIcon } from '@icons/DuplicateIcon';
import { TrashCanIcon } from '@icons/TrashCanIcon';
import { USER_STATUS_KEY } from '@account_module/constants/userKeys';

const ActionCellContainer = tw.div`relative flex items-center justify-end`;
const ActionsContainer = tw.div` absolute right-0 top-[calc(100% + 10px)] border border-solid border-gray-3 rounded p-0.5 z-10 bg-neutral-background shadow-dropdown`;
const OptionButton = tw.button`w-full text-text-and-icon-muted text-xs text-left p-[6px] pr-4 flex items-center hover:bg-gray-3 rounded-sm`;
const ActionButton = tw.button`border border-solid border-gray-3 rounded p-1 w-[28px] h-[28px] flex items-center justify-center hover:bg-neutral-background`;
const Divider = tw.div`w-full h-[1px] bg-gray-3 my-0.5`;

export const ActionCell = ({
  item,
  isLoading,
  currentUser,
  selectedRow,
  isActionCtxOpen,
  usersCount,
  resendInvite,
  setSelectedRow,
  setSelectedUsers,
  setIsActionCtxOpen,
  setIsRemoveUserModalActive,
  onCopyEmail,
  t,
}: ActionCellType): JSX.Element => {
  const { id, email, status } = item;
  const isActive = selectedRow === id && isActionCtxOpen;

  const handleActionButton = () => {
    setSelectedUsers([]);
    setSelectedRow(selectedRow === id ? null : id);
    setIsActionCtxOpen(selectedRow === id ? false : true);
  };

  const copyToClipboard = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(email);

      onCopyEmail && onCopyEmail();
    } else {
      console.error('Copy to clipboard not supported');
    }
  };

  if (isLoading) return <Loader theme='dark' size='sm' />;

  return (
    <ActionCellContainer>
      <ActionButton onClick={handleActionButton} css={[isActive && tw`bg-neutral-background`]}>
        <ThreeDots tw='fill-text-and-icon-muted stroke-text-and-icon-muted' />
      </ActionButton>

      {isActive && (
        <ActionsContainer>
          {currentUser.isAdmin && status !== USER_STATUS_KEY.activated && (
            <OptionButton onClick={resendInvite}>
              <EnvelopeIcon tw='mr-2 stroke-text-and-icon-muted' />
              {t('account_module.settings_page.users_table.action_cell.resend')}
            </OptionButton>
          )}

          <OptionButton onClick={copyToClipboard}>
            <DuplicateIcon tw='mr-2 stroke-text-and-icon-muted' />
            {t('account_module.settings_page.users_table.action_cell.copy')}
          </OptionButton>

          {currentUser.isAdmin && usersCount > 1 && (
            <>
              <Divider />
              <OptionButton
                tw='text-error-text-icon hover:bg-error-bg'
                onClick={() => setIsRemoveUserModalActive(true)}>
                <TrashCanIcon tw='mr-2 stroke-error-text-icon' />
                {t('account_module.settings_page.users_table.action_cell.remove')}
              </OptionButton>
            </>
          )}
        </ActionsContainer>
      )}
    </ActionCellContainer>
  );
};
